/* components/ClientShell.tsx */
"use client";

import React, { useState } from "react";
import AppLayout from "./AppLayout";
import { installWebApiFetchMarker } from "./helpers/installWebApiFetchMarker";
import PhotoUploadQueueManager from "@/components/PhotoUploadQueueManager/PhotoUploadQueueManager";
import DamageUploadQueueManager from "@/components/DamageUploadQueueManager/DamageUploadQueueManager";
import ServiceHistoryUploadQueueManager from "@/components/ServiceHistoryUploadQueueManager/ServiceHistoryUploadQueueManager";

installWebApiFetchMarker();

export default function ClientShell({ children, isNoTrackingRoute = false }) {
  const [isSidebarRightOpen, setIsSidebarRightOpen] = useState(false);

  return (
    <>
      <PhotoUploadQueueManager />
      <DamageUploadQueueManager />
      <ServiceHistoryUploadQueueManager />
      <AppLayout
        isSidebarRightOpen={isSidebarRightOpen}
        setIsSidebarRightOpen={setIsSidebarRightOpen}
        isNoTrackingRoute={isNoTrackingRoute}
      >
        {children}
      </AppLayout>
    </>
  );
}
